import request from "../request";


// Get Order List
// export const getOrderListAPI = (data) => {
//   return new Promise(async (resolve, reject) => {
//     await request
//       .get(`/order`, { params: data })
//       .then((res) => {
//         resolve(res.data);
//       })
//       .catch((e) => {
//         reject(e);
//       });
//   });
// };
export const getOrderListAPI = async (params) => {
  console.log("%c Line:18 🥚 params", "color:#42b983", params);
  try {
    const response = await request.get(`/order`, { params });
    return response.data;
  } catch (error) {
    console.error("Error occurred in getOrderApi:", error);
    throw error;
  }
};
// Get Order Details By Id
export const getOrderDetailsAPI = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`order/` + id)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// Delete Order Details By Id
export const deleteOrderDetailsAPI = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`order/` + id)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Sync Order Payment with Razorpay
export const syncOrderRazorpayAPI = async (id, paymentId = "") => {
  try {
    const response = await request.post(`order/sync-razorpay/` + id, { paymentId });
    return response.data;
  } catch (error) {
    console.error("Error in syncOrderRazorpayAPI:", error);
    throw error;
  }
};

// Mark Order as Paid Manually
export const markOrderPaidAPI = async (id, paymentId = "", note = "") => {
  try {
    const response = await request.post(`order/mark-paid/` + id, { paymentId, note });
    return response.data;
  } catch (error) {
    console.error("Error in markOrderPaidAPI:", error);
    throw error;
  }
};

// Update Order / Payment Status
export const updateOrderStatusAPI = async (id, data) => {
  try {
    const response = await request.put(`order/update-status/` + id, data);
    return response.data;
  } catch (error) {
    console.error("Error in updateOrderStatusAPI:", error);
    throw error;
  }
};